import { Link } from "react-router-dom";
import { MaskedLines, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

const Meta = ({ client }) => (
  <div className="mt-5">
    <h3 className="font-display text-2xl font-bold tracking-tight text-ink md:text-3xl">{client}</h3>
    <dl className="mt-3 space-y-1 font-mono text-[10px] uppercase tracking-[0.18em] text-ink2">
      <div className="flex gap-3">
        <dt>Industry</dt>
        <dd>[INDUSTRY]</dd>
      </div>
      <div className="flex gap-3">
        <dt>Service</dt>
        <dd>[SERVICE PROVIDED]</dd>
      </div>
    </dl>
  </div>
);

const WideProject = ({ client, testId }) => (
  <Reveal>
    <article data-testid={testId} className="group">
      <div className="overflow-hidden">
        <PlaceholderBlock
          label="[PROJECT IMAGE — WIDE 21:9]"
          ratio="21 / 9"
          className="transition-transform duration-500 ease-out group-hover:scale-[1.02]"
        />
      </div>
      <Meta client={client} />
    </article>
  </Reveal>
);

const PairProject = ({ client, testId, delay = 0 }) => (
  <Reveal delay={delay}>
    <article data-testid={testId} className="group">
      <div className="overflow-hidden">
        <PlaceholderBlock
          label="[PROJECT IMAGE — 4:5]"
          ratio="4 / 5"
          className="transition-transform duration-500 ease-out group-hover:scale-[1.03]"
        />
      </div>
      <Meta client={client} />
    </article>
  </Reveal>
);

export const FeaturedWork = () => (
  <section className="py-24 md:py-40" data-testid="featured-work-section">
    <div className="container-ak">
      <h2 className="mb-12 font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl md:mb-20">
        <MaskedLines
          lines={[
            <span key="l1">
              Featured work<span className="text-ember">.</span>
            </span>,
          ]}
        />
      </h2>

      <div className="space-y-16 md:space-y-24">
        <WideProject client="Proof of Talk" testId="featured-project-0" />

        <div className="grid grid-cols-1 gap-16 md:grid-cols-2 md:gap-10 lg:gap-16">
          <PairProject client="Midas Capital" testId="featured-project-1" />
          <PairProject client="VNX" testId="featured-project-2" delay={0.08} />
        </div>

        <WideProject client="Puretive" testId="featured-project-3" />

        <div className="grid grid-cols-1 gap-16 md:grid-cols-2 md:gap-10 lg:gap-16">
          <PairProject client="Salted Social" testId="featured-project-4" />
          <PairProject client="Meducan" testId="featured-project-5" delay={0.08} />
        </div>
      </div>

      <Reveal className="mt-14 md:mt-20">
        <Link to="/work" data-testid="featured-explore-work-btn" className="btn-secondary h-14 px-8 text-base">
          Explore All Work
        </Link>
      </Reveal>
    </div>
  </section>
);
